import { useMemo } from 'react';

import { Grid } from '@mui/material';
import { CommissionType } from '@prisma/client';

import CommissionStat from './CommissionStat';

const getCommissionAmount = (commissions, commissionType) => {
    const commission = commissions.filter((commission) => {
        return commission.commissionType === commissionType;
    });

    const total = commission.reduce((accumulator, currentElement) => {
        return accumulator + currentElement.total;
    }, 0);

    return total;
};

type Commission = {
    commissionType: CommissionType;
    total: number;
};
interface CommissionSummaryProps {
    commissions: Commission[];
    usersCurrency: string;
}

const CommissionSummary = ({ commissions, usersCurrency }: CommissionSummaryProps) => {
    const { terminalCommission, onlineCommission, transactionCommission } = useMemo(() => {
        return {
            terminalCommission: getCommissionAmount(commissions, CommissionType.TERMINAL),
            onlineCommission: getCommissionAmount(commissions, CommissionType.ONLINE),
            transactionCommission: getCommissionAmount(commissions, CommissionType.TRANSACTIONAL),
        };
    }, [commissions]);

    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '0 0 12px 0',
            }}
            gap={1}
        >
            <CommissionStat
                label="Terminal"
                value={terminalCommission}
                usersCurrency={usersCurrency}
            />
            <Grid sx={{ borderLeft: '1px solid #FDC800' }} gap={1} />
            <CommissionStat label="Online" value={onlineCommission} usersCurrency={usersCurrency} />
            <Grid sx={{ borderLeft: '1px solid #FDC800' }} gap={1} />
            <CommissionStat
                label="Transaction"
                value={transactionCommission}
                usersCurrency={usersCurrency}
            />
        </Grid>
    );
};

export default CommissionSummary;
